






import { Component, Vue } from "vue-property-decorator";
import { UtilitiesFunctions } from "@/helpers";
import ProfileDetail from "@/components/privateAreas/ProfileDetail.vue";

@Component({
  components: {
    ProfileDetail
  }
})
export default class CellarView extends Vue {
  handleRoute = UtilitiesFunctions.handleRoute;
  cellar?: any = null;
  mounted() {}
}
